import CalendarIcon from "@uui/Calendar";

import RecommendationChip from "@app/analytics/components/RecommendationChip";

const NonRecurringMeetingBadge = ({ size = "14px" }: { size?: string }) => (
  <RecommendationChip
    backgroundColor="shades.primary.50"
    fontColor="shades.primary.500"
    tooltip="Standalone meeting"
    startIcon={
      <CalendarIcon sx={{ fontSize: size, color: "shades.primary.500" }} />
    }
  />
);

export default NonRecurringMeetingBadge;
